import { StyleSheet } from 'react-native';

import { primitive } from 'styles/constants/primitives';

export const styles = StyleSheet.create({
  separator: { flex: 1 },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  horizontalContainer: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: primitive.spacing.$6,
    gap: primitive.spacing.$4,
  },
  option: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    padding: primitive.spacing.$3,
    borderBottomColor: primitive.$blackOpacity10,
    gap: primitive.spacing.$2,
  },
});
